import type {PolymorphicComponentWithDefault} from '@github-ui/react-polymorphic'
import {Text, type TextProps} from '@primer/react'
import {memo} from 'react'

import {sanitizeTextInputHtmlString} from '../../helpers/sanitize'

type SanitizedHtmlOwnProps = Omit<TextProps, 'children' | 'as'> & {
  children: string
}

/**
 * A Primer <Text /> element with inbuilt sanitization of the the children
 * to support rendering untrusted input within the application.
 *
 * @param props additional props alongside the `children` text to render
 * @param props.asBdi if true, the text will be wrapped in a <bdi> element
 */
const _SanitizedHtml = ({ref, children, ...props}: SanitizedHtmlOwnProps) => {
  // eslint-disable-next-line react/forbid-component-props
  return <Text {...props} dangerouslySetInnerHTML={{__html: sanitizeTextInputHtmlString(children)}} ref={ref} />
}

_SanitizedHtml.displayName = 'SanitizedHtml'

export const SanitizedHtml = memo(_SanitizedHtml) as PolymorphicComponentWithDefault<'span', SanitizedHtmlOwnProps>
